import {FlightMode} from "../FlightMode";
import {FlightModeGameAssets} from "../FlightModeGameAssets";
import {gsap} from "gsap";

export class FreespinsIntro extends PIXI.Container {

    public introSpine:PIXI.spine.Spine;
    public darkening:PIXI.Sprite;

    constructor() {
        super();

        this.darkening = new PIXI.Sprite(PIXI.Texture.WHITE);
        this.darkening.tint = PIXI.utils.string2hex("#0066ff");
        this.darkening.position.set(360, 360);
        this.darkening.anchor.set(0.5, 0.5);
        this.darkening.alpha = 0;
        this.addChild(this.darkening);

        this.introSpine =
            new PIXI.spine.Spine(FlightMode.assetLoader.getSpineAsset(FlightModeGameAssets.INTRO_SPINE));
        this.introSpine.position.set(360,360);
        this.introSpine.alpha = 0;
        this.addChild(this.introSpine);
    }

    public show(scatterCount:number):gsap.core.Timeline {
        return gsap.timeline()
            .add(gsap.to(this.darkening, {alpha: 0.7, duration: 0.25}))
            .add(() => {
                const spins = scatterCount == 3 ? 6 :
                    scatterCount == 4 ? 9 :
                        12;
                this.introSpine.state.setAnimation(0, `FS_Intro_${spins}_Loop`, true);
                this.introSpine.alpha = 1;
            }, '<');
    }

    public hide():gsap.core.Timeline {
        return gsap.timeline()
            .add(gsap.to(this.darkening, {alpha: 0, duration: 0.25}))
            .add(() => {
                this.introSpine.state.setEmptyAnimation(0,0);
                this.introSpine.alpha = 0;
            }, '<');
    }


}